module.exports = __webpack_public_path__ + "img/phone-kolding.12bba871.png";